import { formatPDF } from 'assets/js/pdf-formatter.js';
import { loadReportFields } from 'assets/js/SelectizePlugin-InfiniteScroll';
import { ImageViewerComponent } from 'ng/src/app/core/image-viewer/image-viewer.component';

angular.module('logbook')
.controller('report-view', ['$scope', '$rootScope', '$compile', '$http', '$timeout', '$location', '$q', '$sce', '$route', 'tagStyle', 'reportMapping', 'errorHandler', '$filter',
    function($scope, $rootScope, $compile, $http, $timeout, $location, $q, $sce, $route, tagStyle, reportMapping, errorHandler, $filter) {
		
        var _table,
            parser = new DOMParser(),
            fieldPanelWidth = 172,
            $outputTable = $('#output-table'),
            $reportFields = $('#report-fields'),
            runningScheduledReport = $location.search()['scheduledReportRun'],
            outputType = $location.search()['outputType'];

        $scope.templateSegments = [];
        $scope.$sce = $sce;
        $scope.query = {};
        $scope.notes = [];
        $scope.exceedLimit = false;
        $scope.stopQuery = false;
        $scope.lastQueryCancelled = false;
        $scope.lastTimeUpdated = new Date();
        $scope.skipNextSort = true;
        $scope.runChartQueries = {};
        $scope.chart = {};
        $scope.hadFirstRun = false;
        $scope.destroyed = false;
        $scope.tagStyles = {};

        sessionStorage.setItem("imageFiles", JSON.stringify({}));

        $scope.$on('report-link-clicked', function(newReport)
        {
            $route.reload();
        });

        $scope.getNotes = function(initialLoad, append)
        {
            // Protect against running queries before the report or runtime fields are received
        	if (!$scope.report || !$scope.runtimeFields)
                return;

            // Sets the no entries text on the table and sets it for the data tables object
            if (_table && _table.settings().length)
                $('.dataTables_empty').html(_table.settings()[0].oLanguage.sEmptyTable = 'No matching notes were found.');

            $scope.hadFirstRun = true;
            $scope.queryExecuting = true;
            $scope.lastQueryCancelled = false;
            $scope.cancelGetNotes = $q.defer();
            if (initialLoad)
            {
                $scope.queryStarted = moment();
                $scope.exceedLimit = false;
                $scope.query.page = 0;
                $scope.notes.splice(0, $scope.notes.length);
            }

            if (append)
                $scope.query.page++;
            else
                $scope.query.page = 0;

            let overrideLimit = !isNaN($location.search()['noteLimit']) ? parseInt($location.search()['noteLimit']) : undefined;
            var noteLimit = (overrideLimit) || ($scope.report.noteReturnLimit ? $scope.report.noteReturnLimit : 500),
                trippedLimit = false;

            if ((25 * $scope.query.page >= noteLimit) && !$scope.exceedLimit) {
                trippedLimit = true;
                var limitReachedModal = $('#limit-reached-warning');
                if (($scope.autoRefreshing === null || !$scope.autoRefreshing) && !$scope.autoRefreshFull && !($location.search()['doNotAsk'] || runningScheduledReport))
                    limitReachedModal.modal({backdrop: 'static'})
                                .one('hide.bs.modal', function (e) {
                                    complete();
                                });
                else
                {
                    $scope.stopQuery = ($scope.autoRefreshFull === null || runningScheduledReport) ? true : !$scope.autoRefreshFull;
                    complete();
                }
            } else
                complete();

            function complete()
            {
                if (trippedLimit && $scope.stopQuery) {
                    $timeout(function () {
                        $scope.cancelQuery()
                    });
                    return;
                }
                else if (trippedLimit)
                    $scope.exceedLimit = true;
                $scope.query.sort = $scope.reportView === 'Chart' ? 'noteTime,asc' : getSortFields();
                $scope.query.size = 25;
                $scope.query.report = getReportParam();
                $scope.query.projection = 'noteProjectionWithFastTemplateValues';

                var requestStarted  = moment();

                console.log('Request Started');
                $http.get('/api/notes', {
                    noErrorPopup: true,
                    params: $scope.query,
                    timeout: $scope.cancelGetNotes.promise
                })
                    .then(function (noteResult)
                    {
                        // Blocks requests from proceeding from before a query reset
                        if ($scope.queryStarted > requestStarted)
                            return;

                        var notes = noteResult.data._embedded.notes;
                        Array.prototype.push.apply($scope.notes, notes);

                        if ($scope.query.page < noteResult.data.page.totalPages - 1  && $scope.queryExecuting)
                            $scope.getNotes(false, true);

                        else
                        {
                            $scope.queryExecuting = false;
                            autoRefreshTimeSet();
                            $scope.lastTimeUpdated = new Date();

                            if ($scope.reportView == 'Chart') {
                                $scope.runChartQueries(false, {
                                    templateSegmentIds: getChartableTemplateSegmentsIds(),
                                    notes: $scope.notes,
                                    reportViewEntries: $scope.customFields
                                });
                            }
                        }
                        var imageFiles = [];
                        $scope.notes.forEach(function (note) {
                            if (note.templateValues)
                                note.templateValues.forEach(function (templateValue)
                                {
                                    if (templateValue.fileAttachments) {
                                        templateValue.fileAttachments.forEach((fa) => {
                                            if (fa.contentType && fa.contentType.includes('image'))
                                                imageFiles.push(fa);
                                        })
                                    }
                                    
                                    if (templateValue.commentAttachments)
                                        templateValue.commentAttachments.forEach(function (commentAttachment)
                                        {
                                            if (commentAttachment.contentType &&
                                                commentAttachment.contentType.includes('image')) imageFiles.push(commentAttachment);
                                        });
                                });
                        });

                        notes.forEach(function (note) {
                            imageFiles = imageFiles.concat(
                                note.attachments.filter(function (x) {
                                    if (x.contentType)
                                        return x.contentType.includes('image');
                                    else {
                                        x.contentType = 'unknown';
                                        return false;
                                    }
                                })
                            )
                        });

                        // Store Image file IDs for PDF parsing later
                        sessionStorage.setItem('imageFiles', JSON.stringify(imageFiles
                            .reduce(function (imageObj, current) { imageObj[current.id] = null; return imageObj; },
                                JSON.parse(sessionStorage.getItem('imageFiles')) || {})));

                        if ($scope.reportView != 'Chart' && _table)
                            _table.rows.add(notes).draw(false);

                    })
                    .catch(function(error)
                    {
                        delete $scope.autoRefeshSeconds;
                        
                        if (error !== 'Forbidden')
                        {
                            // Catch for if the query fails unexpectedly instead of user stopped
                            if ($scope.queryExecuting)
                            {
                                errorHandler.handle('An error occurred while running the report.', error, true);
                                $scope.cancelQuery(true);
                            }
                            return;
                        }
                        $scope.cancelQuery(true);
                        
                        $('#report-missing-modal').modal('show')
                    });
            }
        };

        $scope.cancelQuery = function(disableAutoRefresh) {
            disableAutoRefresh = disableAutoRefresh || false;
            $scope.cancelGetNotes.promise.suppressErrorFlag = true;
            $scope.cancelGetNotes.resolve();
            $scope.queryExecuting = false;
            $scope.lastTimeUpdated = new Date();
            $scope.lastQueryCancelled = true;
            if ($scope.reportView == 'Chart') {
                $scope.runChartQueries(false, {
                    templateSegmentIds: getChartableTemplateSegmentsIds(),
                    notes: $scope.notes,
                    reportViewEntries: $scope.customFields
                });
            }
            if ($scope.autoRefreshing && disableAutoRefresh)
                $('.refresh-option[value=0]').click();

            autoRefreshTimeSet(disableAutoRefresh ? 0 : undefined);
        };

        $scope.redrawScreen = function() {
            $scope.showCriteria = !$scope.showCriteria;

            // Normally would use ng-show for this, but waiting for the digest cycle to finish before running
            // columns.adjust() causes ugly delay in table resizing
            $reportFields.toggleClass('hide');

            if ($scope.reportView === 'Chart')
                $scope.chart.update();
            else if (_table)
                _table.columns.adjust();
        };

        $scope.updated = function(autoRefreshed) {
            $scope.autoRefreshing = autoRefreshed = autoRefreshed || false;

            $scope.lastQueryCancelled = false;
            $scope.stopQuery = false;
            $scope.notes = [];

            if ($scope.reportView != 'Chart' && _table)
                _table.clear().draw();

            if ($scope.autoRefreshId)
                clearTimeout($scope.autoRefreshId);

            $scope.getNotes(true);
        };

        /**
         * Filters templateSegments based on sub template id
         * @param {array} segments
         * @param {number|{id:number}} subTemplateId
         * @param {boolean=false} emptyOnNoSub - Indicates whether to return an empty list on no sub template ID
         * @returns {[]|Array}
         */
        $scope.filterFromSubTemplate = function (segments, subTemplateId, emptyOnNoSub)
        {
            emptyOnNoSub = emptyOnNoSub || false;
            subTemplateId = (!isNaN(subTemplateId)) ? subTemplateId : ((subTemplateId && subTemplateId.id) ? subTemplateId.id : null );
            var startIndex = segments.findIndex(function(seg) { return seg.id == subTemplateId });
            if (!subTemplateId || (startIndex < 0)) return (emptyOnNoSub) ? [] : segments;

            var toReturn = [];
            for (var i = startIndex + 1; i < segments.length; i++)
            {
                var segment = segments[i];
                if (!segment || segment.type.id == 5)
                    break;

                toReturn.push(segment);
            }
            return toReturn;
        };
        
        $scope.getReportById = function(reportId)
        {
            return $q(function(resolve)
            {
                reportId = parseInt(reportId);
                
                if (!isNaN(reportId))
                {
                    resolve($http.get('/api/reports', {
                        params: {
                            id: reportId,
                            log: $scope.selectedLog.id
                        }
                    })
                        .then(function(results)
                        {
                            return results.data._embedded.reports[0];
                        }))
                }
                else
                    resolve(undefined)
            })
        };
        
        $scope.getActiveRevision = function(complexId)
        {
            complexId = parseInt(complexId);
            complexId = !isNaN(complexId)
                ? complexId
                : ($scope.report && $scope.report.complexObject)
                    ? $scope.report.complexObject.id
                    : undefined;
    
            return $q(function(resolve)
            {
                if (complexId)
                    resolve($http.get('/api/reports', {
                        params: {
                            'complexObject.id': complexId,
                            activeRevision: true
                        }
                    })
                        .then(function(results)
                        {
                            return results.data._embedded.reports[0];
                        }));
                else
                    resolve(undefined);
            });
        };
        
        $scope.getDraftVersion = function(complexId)
        {
            complexId = parseInt(complexId);
            complexId = !isNaN(complexId)
                ? complexId
                : ($scope.report && $scope.report.complexObject)
                    ? $scope.report.complexObject.id
                    : undefined;
    
            return $q(function(resolve)
            {
                if (complexId)
                    resolve($http.get('/api/reports', {
                        params: {
                            'complexObject.id': complexId,
                            isDraft: true
                        }
                    })
                        .then(function(results)
                        {
                            return results.data._embedded.reports[0];
                        }));
                else
                    resolve(undefined);
            });
        };
        
        $scope.redirectToReportManager = function()
        {
            $('#report-missing-modal, #limit-reached-warning').modal('hide');
            $timeout(function()
            {
                $('.modal-backdrop').remove();
                $location.url('/report-manager').replace();
            });
        };
        
        $scope.getReportPromise = function()
        {
            return $q(function(resolve)
            {
                var reportId = $location.search()['report'];
                var complexId = $location.search()['latest'];
                var draft = !!$location.search()['draft'];
    
                var promises = [
                    $scope.getReportById(reportId),
                    $scope.getActiveRevision(complexId),
                    $scope.getDraftVersion(complexId)
                ];
    
                resolve($q.all(promises)
                    .then(function(results)
                    {
                        var report = { data: draft && results[2] ? results[2] : results[1] || results[0] };
                        if (!report.data)
                            return $q.reject({ error: 'No Report', complex: complexId, reportId: reportId, draft: draft });
            
                        $location.search('report', report.data.id).replace();
                        if ($location.search()['runOnLoad'] || runningScheduledReport)
                            report.data.runOnLoad = true;
                        
                        return $q.all([
                            $q.when(report),
                            $http.get('/api/reportViewEntries', {
                                params: {
                                    report: report.data.id,
                                    sort: 'sortOrder'
                                }
                            })
                        ])
                    }))
    
            });
        };
        
        $scope.setReportPromise = function()
        {
            $scope.reportPromise = $scope.getReportPromise();
    
            $scope.reportPromise
                .then(function(results)
                {
                    if (_table && typeof _table.destroy === 'function')
                        _table.destroy();
                    
                    $scope.report = results[0].data;
            
                    // Sets auto refresh rate based on either saved preference or URL param
                    var refreshSeconds = ($location.search()['refreshRate'] || (($scope.report.autoRefreshSeconds) ? $scope.report.autoRefreshSeconds : 0)).toString();
                    $scope.setRefreshTime(refreshSeconds, false);
            
                    // Sets auto refresh full refresh based on URL param
                    if ($location.search()['fullResults'])
                        $scope.setAutoRefreshSetting('fullResults', $location.search()['fullResults'] || false);
            
            
                    // Creates needed API requests for ChoiceList choices
                    var listIdsToGet = [];
                    var choiceLists = [];
                    results[1].data._embedded.reportViewEntries.forEach(function(viewEntry)
                    {
                        if (viewEntry.templateSegment && viewEntry.templateSegment.choiceList)
                        {
                            var id = viewEntry.templateSegment.choiceList.id;
                            if (!listIdsToGet.includes(id)) listIdsToGet.push(id);
                            choiceLists.push(viewEntry.templateSegment.choiceList);
                        }
                    });
                    var promises = listIdsToGet.map(function (value)
                    {
                        var str = '/api/choiceLists/' + value + '/items';
                        return $http.get(str);
                    });
            
                    var hasSegments = false;
                    if ($scope.report.template)
                    {
                        promises.push($http.get('api/templateSegments', {
                                params: {
                                    'template': $scope.report.template.id,
                                    'sort': 'sortOrder',
                                    'size': 10000
                                }
                            }
                        ));
                    }
            
                    $q.all(promises)
                        .then(function(responses)
                        {
                            if (hasSegments)
                                $scope.templateSegments = $scope
                                    .filterFromSubTemplate(responses[responses.length - 1].data._embedded.templateSegments, $scope.report.subTemplate, true);
                    
                            $scope.reportView = $location.search()['report-view'];
                            if (!$scope.reportView) {
                                var view = $scope.report.outputType.name;
                                switch (view) {
                                    case 'Default':
                                        $scope.reportView = 'Notes';
                                        break;
                                    case 'Custom Tabular View':
                                        $scope.reportView = 'Table';
                                        break;
                                    case 'Custom Chart View':
                                        $scope.reportView = 'Chart';
                                        break;
                                }
                            }
                    
                            $rootScope.title = $scope.report.name + ' - ' + $scope.reportView;
                            $scope.customFields = results[1].data._embedded.reportViewEntries;
    
                            // Set to Notes view as charts are not supported for scheduled reports
                            // or if there are no custom fields and the output is set to be a Table.
                            if (runningScheduledReport && ($scope.reportView === 'Chart' ||
                                (Array.isArray($scope.customFields) && $scope.customFields.length === 0 && $scope.reportView === 'Table')))
                                $scope.reportView = 'Notes';
                    
                            // Assigns ChoiceListChoices to owning ChoiceList
                            choiceLists.forEach(function(choiceList) {
                                for (var i = 0; i < responses.length - (hasSegments) ? 1 : 0; i++) {
                                    var choices = responses[i].data._embedded.choiceListItems;

                                    if (choices && choices.length && choices[0].listId === choiceList.id) {
                                        choiceList.choices = choices;
                                        break;
                                    }
                                }
                            });
                    
                            getInitialSorts();
                    
                            if ($scope.reportView == 'Notes')
                                initializeNotesViewTable();
                            else if ($scope.reportView == 'Table')
                                initializeTabularViewTable();
                    
                            var hasOverridableRules = getRuntimeOverridableRules();
                    
                            if (hasOverridableRules)
                                getRuntimeRuleData();
                            else if ($scope.report.runOnLoad || !$scope.runtimeFields.length)
                                $scope.getNotes(true);
                        });
                
                    },
                    function(error)
                    {
                        errorHandler.handle('Could not load report', JSON.stringify(error), false);
                        $scope.redirectToReportManager();
                        return $q.reject();
                    });
        };
        
        $scope.reload = function()
        {
            $location
                .search('latest', $scope.report.complexObject.id)
                .search('report', null)
                .search('draft', null)
                .replace();
            
            $route.reload()
        };
        
        $scope.setReportPromise();

        function getChartableTemplateSegmentsIds() {
            if ($scope.chartableSegmentsIds)
                return $scope.chartableSegmentsIds;

            var chartableSegmentIds = [],
                chartableSegmentTypes = ['Numeric Input', 'Text Choice', 'Sub Template', 'User Chooser', 'Checkbox','Tag Choice', 'Signoff'];

            $scope.customFields.forEach(function(field) {
                if (field.templateSegment && chartableSegmentTypes.indexOf(field.templateSegment.type.name) > -1)
                    chartableSegmentIds.push(field.templateSegment.id);
            });

            $scope.chartableSegmentsIds = chartableSegmentIds;

            return chartableSegmentIds;
        }

        function getRuntimeOverridableRules() {
            var dateOperators = ['specific-date', 'specific-date-signoff', 'start-date-carry-forward', 'end-date-carry-forward'],
                dateRangeOperators = ['date-range', 'date-range-signoff', 'start-date-range-carry-forward', 'end-date-range-carry-forward'],
                timeRangeOperators = ['time-range', 'time-range-signoff', 'time-added-comments', 'start-time-range-carry-forward', 'end-time-range-carry-forward'],
                tagOperators = ['includes-all-of-tags', 'includes-any-of-tags', 'missing-all-of-tags', 'missing-any-of-tags'],
                userChooserOperators = ['has-pending-signoffs-users-note', 'includes-any-of-users', 'excludes-all-of-users', 'made-by-comments',
                    'not-made-by-comments', 'pending-includes-any-of-signoff', 'includes-any-of-signoff', 'excludes-all-of-signoff'];

            $scope.runtimeFields = (function() {
                var overrides = [],
                    topLevelGroup = $scope.report.queryBuilderJson ? JSON.parse($scope.report.queryBuilderJson).rules : null;
                (function getOverridableRules(group) {
                    if (group) {
                        group.forEach(function(rule) {

                            // Checking for template segments that no longer belong to report
                            if (!rule.rules && !isNaN(rule.id) && $scope.templateSegments.length &&
                                $scope.templateSegments.findIndex(function(segment) { return segment.id === rule.id  }) < 0) return;

                            if (rule.rules)
                                getOverridableRules(rule.rules);
                            else if (rule.data.allowConfigureOnQuery) {
                                if (rule.operator.indexOf('template') > -1)
                                    rule.templateField = true;
                                else if (rule.operator === 'is-numeric' || rule.operator === 'number-attachments')
                                    rule.numericField = true;
                                else if (rule.operator === 'is-checkbox')
                                    rule.checkboxField = true;
                                else if (rule.operator === 'only-turnover' || rule.operator === 'all-turnover')
                                    rule.turnoverField = true;
                                else if (rule.operator.indexOf('contains') > -1 ||
                                    ['filename-attachments', 'extension-attachments'].indexOf(rule.operator) > -1)
                                    rule.textEntryField = true;
                                else if (dateOperators.indexOf(rule.operator) > -1)
                                    rule.dateField = true;
                                else if (dateRangeOperators.indexOf(rule.operator) > -1)
                                    rule.dateRangeField = true;
                                else if (timeRangeOperators.indexOf(rule.operator) > -1) {
                                    rule.timeRangeField = true;
                                    rule.timeType = /time-only/.test(rule.data.htmlTemplateId) ? 'time' : 'calendar';
                                } else if (tagOperators.indexOf(rule.operator) > -1)
                                    rule.tagField = true;
                                else if (userChooserOperators.indexOf(rule.operator) > -1)
                                    rule.userField = true;
                                else if (rule.data.choiceListId)
                                    rule.choiceListField = true;

                                overrides.push(rule);
                            }
                        });
                    }
                })(topLevelGroup);

                return overrides;
            })();

            return $scope.runtimeFields.length;
        }

        function getRuntimeRuleData() {
            var templatesNeeded = false,
                tagsNeeded = false,
                usersNeeded = false,
                textChoices = new Set();

            $scope.runtimeFields.forEach(function(rule) {
                if (rule.templateField)
                    templatesNeeded = true;
                else if (rule.tagField)
                    tagsNeeded = true;
                else if (rule.userField)
                    usersNeeded = true;
                else if (rule.choiceListField)
                    textChoices.add(rule.data.choiceListId);
            });

            if (templatesNeeded) {
                $scope.reportTemplates =
                    $http.get('api/templates', {
                        params: {
                            log: $scope.selectedLog.id,
                            projection: 'templateProjectionWithSubTemplates'
                        }
                    })
                    .then(function(result)
                    {
                        return result.data._embedded.templates.map(function(template) {
                            if (template.isDefaultTemplate)
                                template.id = 'Basic Note';
                            
                            return template;
                        });
                    });
            }

            if (tagsNeeded) {
                $scope.tagValues =
                    $http.get('api/tagValues', {
                        params: {
                            log: $scope.selectedLog.id,
                            sort: 'viewString',
                            size: 20,
                            page: 0
                        }
                    })
                        .then(function(result) {
                            return result.data._embedded.tagValues;
                        });
            }

            if (usersNeeded) {
                $scope.logUsers =
                    $http.get('api/logBookUsers', {
                        params: {
                            historicalLogUser: $scope.selectedLog.id
                        }
                    })
                        .then(function(result) {
                            result = result.data._embedded.logBookUsers.map(function(usr) {
                                return {
                                    id: usr.id,
                                    name: usr.firstName + ' ' + usr.lastName
                                };
                            });
                            result.push({id: 'current', name: 'Current User'});
                            result.sort();
                            return result;
                        });
            }

            if (textChoices.size) {
                $scope.choiceListItems = {};

                textChoices.forEach(function(choiceListId) {
                    $scope.choiceListItems[choiceListId] =
                        $http.get('api/choiceListItems', {
                            params: {
                                list: choiceListId,
                                size: 10000,
                                sort: 'asc'
                            }
                        })
                            .then(function(result) {
                                return result.data._embedded.choiceListItems;
                            });
                });
            }
        }

        $scope.showNoteDetail = function(href, index) {
            var reportView = $location.search()['report-view'],
                overrides = $location.search()['overrides'] ? $location.search()['overrides'] : '';

            $location.url('/note-detail')
                .search('note', href)
                .search('query', JSON.stringify($scope.query))
                .search('index', index)
                .search('return-location', 'report')
                .search('log', $scope.selectedLog.id)
                .search('report', $scope.report.id)
                .search('report-view', reportView)
                .search('overrides', overrides);
        };

        $scope.$on('destroy', $scope.cancelQuery);

        $scope.$on('LastRepeaterElement', function() {
            var overrides = $location.search()['overrides'] ? JSON.parse($location.search()['overrides']) : null;

            $reportFields.find('.specific-date').each(function() {
                var reportFieldId = $(this).data('report-field-id'),
                    runtimeField = $scope.runtimeFields.find(function(field) {
                        return field.data.reportFieldId === reportFieldId;
                    });

                if (overrides && overrides.hasOwnProperty(reportFieldId)) {
                    runtimeField.value = overrides[reportFieldId];
                    runtimeField.changed = true;
                }

                var date = runtimeField.value[runtimeField.value.length - 1];

                var $picker = $(this).datetimepicker({
                    showTodayButton: true,
                    showClear: true,
                    format: 'L',
                    inline: true
                });

                $picker.data('DateTimePicker').date(getDateTimePickerValue(date));

                $picker.on('dp.change', function(e) {
                    runtimeField.value = ['Specific Date', e.date ? e.date.format('L') : ''];
                    runtimeField.changed = true;
                });

                fieldPanelWidth = Math.max(fieldPanelWidth, 272);
            });

            $reportFields.find('.date-time-picker > div').each(function() {
                var reportFieldId = $(this).closest('[ng-if]').data('report-field-id'),
                    runtimeField = $scope.runtimeFields.find(function(field) {
                        return field.data.reportFieldId === reportFieldId;
                    });

                if (overrides && overrides.hasOwnProperty(reportFieldId)) {
                    runtimeField.value = overrides[reportFieldId];
                    runtimeField.changed = true;
                }

                var period,
                    getPeriodStart = $(this).parent().index() === 0,
                    getPreviousPeriod;

                if (runtimeField.value.length === 1) {
                    period = runtimeField.value[0].split(' ');
                    getPreviousPeriod = period[0] === 'Last';
                    period = period[1];
                }
                else {
                    var startIndex = (runtimeField.timeType === 'time' || runtimeField.operator === 'time-added-comments') ? 0 : 1;

                    period = runtimeField.value[getPeriodStart ? startIndex : runtimeField.value.length - 1];
                }

                var $picker = $(this).datetimepicker({
                    showTodayButton: true,
                    showClear: true,
                    format: runtimeField.dateRangeField ? 'L' :
                        runtimeField.timeType === 'calendar' ? 'L HH:mm' :
                            'H:mm',
                    showClose: true,
                    allowInputToggle: true
                });

                $picker.data('DateTimePicker').date(getDateTimePickerValue(period, getPeriodStart, getPreviousPeriod));

                $picker.on('dp.change', function(e) {
                    var values = $(this).closest('[ng-if]')
                        .find('input')
                        .map(function() {
                            return this.value;
                        })
                        .get();

                    if (runtimeField.dateRangeField)
                        values.unshift('Between Dates');
                    else if (runtimeField.timeType == 'calendar' && runtimeField.field !== 'comments')
                        values.unshift('Between Dates/Times');

                    runtimeField.value = values;
                    runtimeField.changed = true;
                });

                fieldPanelWidth = Math.max(fieldPanelWidth, runtimeField.dateRangeField ? 336 :
                                                            runtimeField.timeType == 'calendar' ? 428 :
                                                            242);
            });

            $reportFields.find('.numeric > :input').each(function() {
                var reportFieldId = $(this).parent().data('report-field-id'),
                    runtimeField = $scope.runtimeFields.find(function(field) {
                        return field.data.reportFieldId === reportFieldId;
                    });

                if (overrides && overrides.hasOwnProperty(reportFieldId)) {
                    runtimeField.value = overrides[reportFieldId];
                    runtimeField.changed = true;
                }

                this.value = runtimeField.value[this.tagName == 'SELECT' ? 0 : 1];

                $(this).change(function() {
                    runtimeField.value[$(this).index()] = this.value;
                    runtimeField.changed = true;
                });

                fieldPanelWidth = Math.max(fieldPanelWidth, 270);
            });

            $reportFields.find('.checkbox select, .turnover input').each(function() {
                var $container = $(this).closest('[ng-if]'),
                    reportFieldId = $container.data('report-field-id'),
                    runtimeField = $scope.runtimeFields.find(function(field) {
                        return field.data.reportFieldId === reportFieldId;
                    }),
                    isTurnover = $container.hasClass('turnover');

                if (overrides && overrides.hasOwnProperty(reportFieldId)) {
                    runtimeField.value = overrides[reportFieldId];
                    runtimeField.changed = true;
                }

                if (isTurnover)
                    this.checked = runtimeField.value;
                else
                    this.value = runtimeField.value;

                $(this).change(function() {
                    runtimeField.value = isTurnover ? this.checked : this.value;
                    runtimeField.changed = true;
                });

                if (!isTurnover)
                    fieldPanelWidth = Math.max(fieldPanelWidth, 260);
            });

            $reportFields.find('.text-entry > input').each(function() {
                var reportFieldId = $(this).parent().data('report-field-id'),
                    runtimeField = $scope.runtimeFields.find(function(field) {
                        return field.data.reportFieldId === reportFieldId;
                    });

                if (overrides && overrides.hasOwnProperty(reportFieldId)) {
                    runtimeField.value = overrides[reportFieldId];
                    runtimeField.changed = true;
                }

                var isArray = Array.isArray(runtimeField.value);

                this.value = isArray ? runtimeField.value[0] : runtimeField.value;

                $(this).change(function() {
                    if (isArray)
                        runtimeField.value[0] = this.value;
                    else
                        runtimeField.value = this.value;

                    runtimeField.changed = true;
                });

                fieldPanelWidth = Math.max(fieldPanelWidth, 365);
            });

            $reportFields.find('.picker-control > input').each(function() {
                var $input = $(this),
                    reportFieldId = $input.parent().data('report-field-id'),
                    runtimeField = $scope.runtimeFields.find(function(field) {
                        return field.data.reportFieldId === reportFieldId;
                    }),
                    promise, textField = 'name';

                if (overrides && overrides.hasOwnProperty(reportFieldId)) {
                    runtimeField.value = overrides[reportFieldId];
                    runtimeField.changed = true;
                }

                var infiniteScrolling = false;
                var selectizeType;
                if (runtimeField.templateField)
                {
                    selectizeType = 'templates';
                    promise = $scope.reportTemplates;
                } else if (runtimeField.tagField)
                {
                    infiniteScrolling = true;
                    selectizeType = 'tagValues';
                    promise = $scope.tagValues;
                    textField = 'viewString';
                } else if (runtimeField.userField)
                {
                    promise = $scope.logUsers;
                } else if (runtimeField.choiceListField) {
                    infiniteScrolling = true;
                    selectizeType = 'choiceListItems';
                    promise = $scope.choiceListItems[runtimeField.data.choiceListId];
                    textField = 'value';
                }
                else
                {
                    textField = 'value';
                }

                promise.then(function(values)
                {

                    var optGroups = [];


                    if (values.length && values.every(function(ex) { return ex.subTemplates }))
                    {
                        optGroups = values
                            .filter(function(template) { return template.subTemplates.length && template.templateType.id === 1 })
                            .map(function(template) { return { groupName: template.name, id: template.id } });
                    }

                    $input.selectize({
                        preload: true,
                        valueField: runtimeField.choiceListField ? 'value' : 'id',
                        labelField: textField,
                        searchField: function (infiniteScrolling) {
                            var searchFields = [textField];
                            if (infiniteScrolling) searchFields.push('override');
                            if (optGroups.length) searchFields.push('groupName');
                            return searchFields;
                        }(infiniteScrolling),
                        optgroups: (optGroups.length) ? optGroups : null,
                        optgroupField: 'groupName',
                        optgroupLabelField: 'groupName',
                        optgroupValueField: 'groupName',
                        sortField: [
                            {field: 'groupName', direction: 'asc'},
                            {field: textField, direction: 'asc'}
                        ],
                        plugins: function (infiniteScrolling) {
                            var plugins = ['remove_button'];
                            if (infiniteScrolling) plugins.push('infinite_scroll');
                            return plugins;
                        }(infiniteScrolling),
                        dropdownParent: 'body',
                        loadThrottle: (infiniteScrolling) ? 600 : 0,
                        load: function(query, callback)
                        {
                            var self = this;
                            if (!query.length)
                                return;

                            if (!infiniteScrolling && selectizeType !== 'tagValues' && selectizeType !== 'choiceListItems') return;
                            query = JSON.parse(query);

                            var instanceParams = {};

                            if (selectizeType === 'tagValues') {
                                instanceParams = {
                                    log: $scope.selectedLog.id,
                                    page: query.page,
                                    matches: query.search,
                                    size: 20,
                                    sort: (selectizeType !== 'tagValues') ? 'value' : 'viewString'
                                };
                            } else if (selectizeType === 'choiceListItems') {
                                instanceParams = {
                                    list: runtimeField.data.choiceListId,
                                    page: query.page,
                                    matches: query.search,
                                    size: 20,
                                    sort: 'asc'
                                };
                            }

                            var parentTag = runtimeField.data.parentTag;

                            var urlParams = Object.keys(instanceParams).map(function(field)
                            {
                                return encodeURI(field + '=' + instanceParams[field]).replace('/%20/', '+');
                            }).join('&');

                            if (parentTag)
                            {
                                urlParams += encodeURI('&parentDepthSpec=' + parentTag.id);
                                if (parentTag.depth) urlParams += encodeURI('&parentDepthSpec=' + parentTag.depth);
                            }

                            var url = 'api/' + selectizeType + '?' + urlParams;
                            if (query.page > self.maxPages) return;
                            $.ajax({
                                url: url,
                                type: 'get',
                                dataType: 'json',
                                success: function(data)
                                {
                                    self.maxPages = data.page.totalPages;
                                    // Adds override search term to match the query for search phrasing as logbook does the search
                                    // matches for phrase searching
                                    if (query.search.match('(".+")+'))
                                    {
                                        data._embedded[selectizeType].forEach(function (item) {
                                            item.override = query.search;
                                        });
                                    }

                                    callback(data._embedded[selectizeType]);


                                    // Highlights quoted expressions
                                    var expression = /"([^"]*)"/g;
                                    var dropdown = self.$dropdown_content;
                                    var match = expression.exec(query.search);
                                    while (match != null)
                                    {
                                        self.highlight(dropdown, match[1]);
                                        match = expression.exec(query.search);
                                    }
                                },
                                error: function()
                                {
                                    callback()
                                }
                            });
                        },
                        onInitialize: function()
                        {
                            switch (selectizeType)
                            {
                                case 'tagValues':
                                case 'choiceListItems':
                                    this.setValue(runtimeField.value, true);
                                    loadReportFields(this, $scope.report.id, runtimeField.data.reportFieldId, selectizeType);
                                    break;

                                case 'templates':
                                    var subGroups = [];

                                    var options = values.filter(function(template)
                                    {
                                       if (template.subTemplates.length && template.templateType.id === 1)
                                       {
                                           subGroups = subGroups.concat(template.subTemplates.map(function(subTemplate)
                                           {
                                               return { name: subTemplate.name, groupName: template.name, id: subTemplate.id + 'S' }
                                           }))
                                       }
                                       else
                                           return true;
                                    })
                                        .map(function(template)
                                    {
                                        var toReturn = Object.assign({}, template);
                                        toReturn.id = toReturn.id + 'T';
                                        return toReturn;
                                    });

                                    this.addOption(options.concat(subGroups));
                                    this.setValue(runtimeField.value, true);
                                    break;

                                default:
                                    this.addOption(values);
                                    this.setValue(runtimeField.value, true);
                            }
                        },
                        onChange: function(value)
                        {
                            runtimeField.value = value.split(',');
                            runtimeField.changed = true;
                        }
                    });
                });

                fieldPanelWidth = Math.max(fieldPanelWidth, 365);
            });

            $reportFields.width(fieldPanelWidth);

            if ($scope.report.runOnLoad || !$scope.runtimeFields.length)
                $scope.getNotes(true);
            else
                $reportFields.removeClass('hide');

            $scope.showCriteria = !$scope.report.runOnLoad;
        });

        function getDateTimePickerValue(period, getStartDate, getPrevious) {
            if (!period && period !== 0)
                return null; // picker will not have a default value

            if (period === 'Today')
                return moment();

            if (period === 'Yesterday')
                return moment().subtract(1, 'day');

            // if (typeof period == 'number')
            if (!isNaN(period))
                return moment().subtract(period, 'days');

            if (moment(period).isValid())
                return period;

            if (['Week', 'Month', 'Quarter', 'Year'].indexOf(period) > -1) {
                if (getStartDate)
                    return moment().subtract(getPrevious ? 1 : 0, period).startOf(period === 'Week' ? 'isoWeek' : period);
                else
                    return moment().subtract(getPrevious ? 1 : 0, period).endOf(period === 'Week' ? 'isoWeek' : period);
            }

            if (moment.weekdays().indexOf(period) > -1) {
                var today = moment().isoWeekday(),
                    previousWeekday = moment().isoWeekday(period).day();

                if (today > previousWeekday)
                    return moment().isoWeekday(previousWeekday);

                return moment().subtract(1, 'week').isoWeekday(previousWeekday);
            }

            return period;
        }


        /**
         * Maps payload templates to template and sub templates
         * @param {{templates:Array}} payload
         * @returns {*} Updated payload
         */
        function mapTemplateValues(payload)
        {
            if (payload.templates)
            {
                var templates = [];
                var subTemplates = [];

                var newObj = {};
                for (var field in payload)
                {
                    if (field === 'templates') continue;
                    newObj[field] = payload[field];
                }

                payload.templates.forEach(function(template)
                {
                    var url = template.substring(0, template.length - 1);
                    if (url.includes('Basic Note'))
                    {
                        newObj.flags.includeBasicNotes = true;
                        return;
                    }
                    switch(template[template.length - 1])
                    {
                        case 'T':
                            templates.push(url);
                            break;
                        case 'S':
                            subTemplates.push(url.replace('templates', 'templateSegments'));
                            break;
                    }
                });
                newObj.templates = templates;
                newObj.subTemplates = subTemplates;

                return newObj;
            }
            return payload;
        }

        function getReportParam() {
            var overrides = {},
                overrideValues = {},
                reportParam = $scope.report.id;

            $scope.runtimeFields.forEach(function(field) {
                if (field.changed) {
                    var payload = reportMapping.createPayload(field, null, null, true);

                    overrides[field.data.reportFieldId] = JSON.stringify(mapTemplateValues(payload));
                    overrideValues[field.data.reportFieldId] = field.value;
                }
            });

            var hasOverrides = Object.keys(overrides).length;
            if (hasOverrides) {
                $location.search('overrides', JSON.stringify(overrideValues)).replace();

                reportParam += ',' + JSON.stringify(overrides);
            }

            return reportParam;
        }

        function getSortFields() {
            var sortFields;
            // List of field names to not sort by
            var blockList = ['attachments'];
            var sortableFields = ($scope.customFields) ? $scope.customFields.filter(function (customField)
            {
                return (customField.noteField && customField.noteField.name)
                    ? !blockList.includes(customField.noteField.name)
                    : true;
            }) : [];

            if ($scope.reportView === 'Notes') {
                if (!$scope.primarySortNotes)
                    return "timeframe,asc";
                else
                    sortFields = ['primarySortNotes', 'secondarySortNotes'];
            } else {
                if (!sortableFields.length)
                    return "noteTime,asc";
                if (!$scope.primarySort) {
                    var column = $scope.primarySort = sortableFields[0];
                    
                    if (typeof $scope.primarySortDescending !== 'boolean')
                    {
                        let tableOrder = _table.order();
                        if (Array.isArray(tableOrder) && Array.isArray(tableOrder[0]))
                            $scope.primarySortDescending = tableOrder[0][1] === 'desc';
                        else
                            $scope.primarySortDescending = true;
                    }
                    
                    let sortStr = ($scope.primarySortDescending) ? ',desc' : ',asc'
                    
                    if (column.noteField)
                        return column.noteField.name + sortStr;
                    else
                        return `templateValue_${column.templateSegment.id}${sortStr}`;
                } else
                    sortFields = ['primarySort', 'secondarySort'];
            }

            var sorts = [];

            sortFields.forEach(function(sortField, index) {
                var sort;

                if ($scope[sortField]) {
                    sort = $scope[sortField].noteField ?
                        $scope[sortField].noteField.name : ($scope[sortField].templateSegment ?
                            'templateValue_' + $scope[sortField].templateSegment.id : $scope[sortField]);

                    sort = (blockList.includes(sort)) ? '' : sort + ',' + ($scope[sortField + 'Descending'] ? 'desc' : 'asc');
                }

                if (sort)
                    sorts.push(sort);
            });

            return sorts;
        }

        $scope.setReportView = function(view) {
            if ($scope.reportView === view)
                return;

            var previousView = $scope.reportView;

            $rootScope.title = $scope.report.name + ' - ' + view;
            $scope.reportView = view;

            if (view == 'Chart' || previousView != 'Chart') {
                if (_table) {
                    _table.off('order.dt');
                    _table.destroy();
                }
                if ($scope.queryExecuting)
                    $scope.getNotes(true, true);

                $outputTable.empty();
            }

            // ng-show/hide won't do for this because precise timing is needed to smoothly render DataTables
            $('#table-wrapper').toggleClass('hide', view == 'Chart');
            $('#chart-wrapper').toggleClass('hide', view != 'Chart');

            if (view == 'Notes')
                initializeNotesViewTable();
            else if (view == 'Table')
                initializeTabularViewTable();
            else if ($scope.notes.length) {
                $scope.updated();
            }

            // Overrides the column visibility from table view when switching to note view
            if (_table && $scope.reportView === 'Notes')
                _table.columns().every(function()
                {
                       this.visible(true);
                });

            if ($scope.notes.length) {
                if (view == 'Chart') {
                    $scope.runChartQueries(false, {
                        templateSegmentIds: getChartableTemplateSegmentsIds(),
                        notes: $scope.notes,
                        reportViewEntries: $scope.customFields
                    });
                }
                else if (_table)
                    _table.rows.add($scope.notes).draw();
            }

            $location.search('report-view', view).replace();
        };

        function initializeNotesViewTable() {
            var columns = [
                noteFieldColumns.timeframe,
                noteFieldColumns.note,
                noteFieldColumns.attachments,
                noteFieldColumns.turnover,
                noteFieldColumns.createdBy
            ],
            columnNames = ['timeframe', 'note', 'attachments', 'turnover', 'createdBy'],
            order = [];

            if ($scope.primarySortNotes) {
                order.push([columnNames.indexOf($scope.primarySortNotes), $scope.primarySortNotesDescending ? 'desc' : 'asc']);
                if ($scope.secondarySortNotes) {
                    order.push([columnNames.indexOf($scope.secondarySortNotes), $scope.secondarySortNotesDescending ? 'desc' : 'asc']);
                }
            } else
                order.push([0,'asc']);

            _table = $outputTable.DataTable({
	            language: {
	                emptyTable: ($scope.report.runOnLoad || $scope.hadFirstRun) ? 'No matching notes were found.' : 'When ready, press Run Report.'
				},
                processing: true,
                deferRender: true,
                pageLength: $scope.report.pageSize || 10,
                dom: "<'row'<'col-sm-6'iB><'col-sm-6'f>>" +
                     "<'row'<'col-sm-12'tr>>" +
                     "<'row'<'col-sm-6'l><'col-sm-6'p>>",
                search: {
                    search: _table ? _table.search() : ''
                },
                buttons: getTableButtons(),
                order: order,
                columns: columns,
                scrollY: "calc(100vh - 310px)",
                scrollCollapse: true,
                // infoCallback: getInfoMessage,
                createdRow: function(row, data, dataIndex) {
                    $compile(row)($scope);

                    if (data.directive && row.cells[data.directive.tdIndex])
                    {
                        var directive = row.cells[data.directive.tdIndex].childNodes[0];

                        $compile(directive)(data.directive.scope);
                    }
                },
                drawCallback: checkIfMaxHeightNeeded
            });

            _table.on('order.dt', function() {
                handleSort(false);
            });
        }

        function initializeTabularViewTable() {
            if ($scope.customFields.length) {
                var columns = $scope.customFields.map(function(field) {
                    var column = field.noteField ?
                        noteFieldColumns[field.noteField.name] :
                        getTabularViewColumn(field);

                    if (field.noteField && field.name)
                        column.title = field.name;

                    column.visible = !field.initiallyHidden;

                    return column;
                }),
                order = [];

                if ($scope.primarySort) {
                    var colIndex;
                    if ($scope.primarySort.noteField) {
                        colIndex = columns.findIndex(function(col) {
                            return col.className.includes('nf_' + $scope.primarySort.noteField.id);
                        });
                    } else {
                        colIndex = columns.findIndex(function(col) {
                            return col.className.includes('ts_' + $scope.primarySort.templateSegment.id);
                        });
                    }
                    order.push([colIndex, $scope.primarySortDescending ? 'desc' : 'asc']);

                    if ($scope.secondarySort) {
                        if ($scope.secondarySort.noteField) {
                            colIndex = columns.findIndex(function(col) {
                                return col.className.includes('nf_' + $scope.secondarySort.noteField.id);
                            });
                        } else {
                            colIndex = columns.findIndex(function(col) {
                                return col.className.includes('ts_' + $scope.secondarySort.templateSegment.id);
                            });
                        }
                        order.push([colIndex, $scope.secondarySortDescending ? 'desc' : 'asc']);
                    }
                } else
                    order.push([0,'asc']);

				_table = $outputTable.DataTable({
                    language: {
                        emptyTable: ($scope.report.runOnLoad || $scope.hadFirstRun) ? 'No matching notes were found.' : 'When ready, press Run Report.'
                    },
                    processing: true,
                    deferRender: true,
                    pageLength: $scope.report.pageSize || 10,
                    dom: "<'row'<'col-sm-6'iB><'col-sm-6'f>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row'<'col-sm-6'l><'col-sm-6'p>>",
                    search: {
                        search: _table ? _table.search() : ''
                    },
                    buttons: getTableButtons(),
                    scrollX: true,
                    scrollY: "calc(100vh - 310px)",
                    scrollCollapse: true,
                    order: order,
                    columns: columns,
                    // infoCallback: getInfoMessage,
                    createdRow: function(row, data, dataIndex) {
                        $compile(row)($scope);

                        if (data.directive && row.cells[data.directive.tdIndex]) {
                            var directive = row.cells[data.directive.tdIndex].childNodes[0];

                            $compile(directive)(data.directive.scope);
                        }
                    },
                    drawCallback: checkIfMaxHeightNeeded
                });

                _table.on('order.dt', function() {
                    handleSort(true);
                });
            } else {
                _table = undefined;
                $outputTable.html('<p class="text-center" style="height: 40px; margin-top: 30px;">No output columns selected</p>');
            }
        }

        function getInitialSorts() {
            var search = $location.search();

            if (search['pSort']) {
                var id = parseInt(search['pSort'].substr(3)),
                    field;
                if (search['pSort'].substr(0,3) === 'nf_')
                    field = $scope.customFields.find(function(field) {
                        return field.noteField && field.noteField.id === id;
                    });
                else
                    field = $scope.customFields.find(function(field) {
                        return field.templateSegment && field.templateSegment.id === id;
                    });

                $scope.primarySort = field || $scope.report.primarySort;
                $scope.primarySortDescending = field ? search['pSortD'] === 'd' : $scope.report.primarySortDescending;
            } else {
                $scope.primarySort = $scope.report.primarySort;
                $scope.primarySortDescending = $scope.report.primarySortDescending;
            }

            if (search['sSort']) {
                if (search['sSort'] === null) {
                    $scope.secondarySort = null;
                    $scope.secondarySortDescending = null;
                } else {
                    var id = parseInt(search['sSort'].substr(3)),
                        field;
                    if (search['sSort'].substr(0,3) === 'nf_')
                        field = $scope.customFields.find(function(field) {
                            return field.noteField && field.noteField.id === id;
                        });
                    else
                        field = $scope.customFields.find(function(field) {
                            return field.templateSegment && field.templateSegment.id === id;
                        });

                    $scope.secondarySort = field || $scope.report.secondarySort;
                    $scope.secondarySortDescending = field ? search['sSortD'] === 'd' : $scope.report.secondarySortDescending;
                }
            } else {
                $scope.secondarySort = $scope.report.secondarySort;
                $scope.secondarySortDescending = $scope.report.secondarySortDescending;
            }
        }

        function handleSort(tabular) {
            if (!$scope.skipNextSort) {
                var order = _table.order();

                if (order.length === 3)
                    order.splice(1,1);

                if (tabular) {
                    $scope.primarySort = $scope.customFields[order[0][0]];
                    $scope.primarySortDescending = order[0][1] === 'desc';
                    $scope.secondarySort = order.length === 2 ? $scope.customFields[order[1][0]] : null;
                    $scope.secondarySortDescending = $scope.secondarySort && order[1][1] === 'desc';

                    if (!sortsMatch()) {
                        var pSort = $scope.primarySort.noteField ?
                                        'nf_' + $scope.primarySort.noteField.id : 'ts_' + $scope.primarySort.templateSegment.id,
                            pSortD = $scope.primarySortDescending ? 'd' : 'a',
                            sSort = !$scope.secondarySort ? 'null' : $scope.secondarySort.noteField ?
                                        'nf_' + $scope.secondarySort.noteField.id : 'ts_' + $scope.secondarySort.templateSegment.id,
                            sSortD = $scope.secondarySortDescending ? 'd' : 'a';
                        $timeout(function() {
                            $location.search('pSort', pSort).replace();
                            $location.search('pSortD', pSortD).replace();
                            $location.search('sSort', sSort).replace();
                            $location.search('sSortD', sSortD).replace();
                        });
                    } else {
                        $timeout(function() {
                            $location.search('pSort', null).replace();
                            $location.search('pSortD', null).replace();
                            $location.search('sSort', null).replace();
                            $location.search('sSortD', null).replace();
                        });
                    }
                } else {
                    var columnNames = ['timeframe', 'note', 'attachments', 'turnover', 'createdBy'];
                    $scope.primarySortNotes = columnNames[order[0][0]];
                    $scope.primarySortNotesDescending = order[0][1] === 'desc';
                    $scope.secondarySortNotes = order.length === 2 ? columnNames[order[1][0]] : null;
                    $scope.secondarySortNotesDescending = $scope.secondarySortNotes && order[1][1] === 'desc';
                }

                if ($scope.lastQueryCancelled)
                    $scope.updated($scope.autoRefreshing);

                $scope.skipNextSort = true;
                _table.order(order).draw();
            } else
                $scope.skipNextSort = false;
        }

        function sortsMatch() {
            if (!$scope.report.primarySort)
                return false;
            if ($scope.report.primarySort.noteField) {
                if (!$scope.primarySort.noteField)
                    return false;
                else if ($scope.report.primarySort.noteField.id !== $scope.primarySort.noteField.id)
                    return false;
            } else if ($scope.report.primarySort.templateSegment) {
                if (!$scope.primarySort.templateSegment)
                    return false;
                else if ($scope.report.primarySort.templateSegment.id !== $scope.primarySort.templateSegment.id)
                    return false;
            }
            if (!!$scope.report.primarySortDescending !== !!$scope.primarySortDescending)
                return false;

            if (($scope.report.secondarySort && !$scope.secondarySort) || (!$scope.report.secondarySort && $scope.secondarySort))
                return false;
            else if ($scope.report.secondarySort && $scope.secondarySort) {
                if ($scope.report.secondarySort.noteField) {
                    if (!$scope.secondarySort.noteField)
                        return false;
                    else if ($scope.report.secondarySort.noteField.id !== $scope.secondarySort.noteField.id)
                        return false;
                } else if ($scope.report.secondarySort.templateSegment) {
                    if (!$scope.secondarySort.templateSegment)
                        return false;
                    else if ($scope.report.secondarySort.templateSegment.id !== $scope.secondarySort.templateSegment.id)
                        return false;
                }
                if (!!$scope.report.secondarySortDescending !== !!$scope.secondarySortDescending)
                    return false;
            }

            return true;
        }

        function checkIfMaxHeightNeeded() {
            var api = _table || this.api(),
                noteCells = api.column('note:name', { page:'current' }).nodes();

            if (noteCells) {
                noteCells.to$().each(function() {
                    if (this.firstElementChild.dataset.maxHeight &&
                        this.firstElementChild.scrollHeight > this.firstElementChild.clientHeight &&
                        $(this).children('.toggle-more').length == 0) {

                        this.firstElementChild.insertAdjacentHTML('afterend', '<a class="toggle-more">Show More</a>');
                    }
                });
            }
        }

        function getInfoMessage(settings, start, end, max, total, pre) {
            if ($scope.totalNotes) {
                var message = 'Showing ' + end + ' of ' + $scope.totalNotes + ' total results';

                if (total != max)
                    message += ' (' + (max - total) + ' results filtered)';

                return message;
            }

            if ($scope.totalNotes === 0)
                return 'No notes match the specified criteria';

            return '';
        }

        function getTabularViewColumn(field) {
            return {
                data: 'templateValues',
                title: field.name || field.templateSegment.longName,
                className: (field.templateSegment.type.name === 'Numeric Input' ? 'dt-body-right' : 'dt-body-left') + ' ts_' + field.templateSegment.id,
                render: function(data, type, row, meta) {
                    var templateValues = data.find(function(templateValue) {
                        return templateValue.templateSegmentId == field.templateSegment.id;
                    });

                    if (!templateValues)
                        return '';

                    let htmlString = '';

                    /**
                       * Wraps the htmlString with any comments belonging to the templateValue
                       * If htmlString is undefined and a value is passed, that value is wrapped.
                       * @param value - To wrap if htmlString is undefined.
                       * @returns {string} - htmlString
					*/
					const commentFormatter = function(value, alignment) {
						const isRichText = !alignment;

						if (!htmlString.length && value != undefined) {
							let classList = 'report-column-cell';
							isRichText && (classList += ' ql-editor p-p-0');

							htmlString = `<div class="${classList}">${value}</div>`;
						}

						let appendingString = '';
						const comment = templateValues.comment;
						const style = isRichText ? '' : ` style="text-align: ${alignment.toLowerCase()}"`;
						
                        if (comment)
							appendingString += '<div style="color: black; font-weight: bold">' + comment + '</div>';
						
                        if (templateValues.commentAttachments && templateValues.commentAttachments.length) {
                            templateValues.commentAttachments.sort(function(val1, val2) {
                                return (val1.contentType && val1.contentType.includes('image')) ? 1 : -1
                            });

                            appendingString = formatAttachments(templateValues.commentAttachments, row.id, appendingString);
                        }

                        if (comment || templateValues.commentAttachments.length)
                            appendingString = `<br><div alt="comments" class="template-comment export-remove">${appendingString}</div>`
                        
						htmlString += appendingString;

                        return tagStyleWrapper(`<div${style}>${htmlString}</div>`, meta, row.tagValues, meta.col);
                    };

                    switch (field.templateSegment.type.name) {
                        case 'Numeric Input':

                            var value = templateValues.numericValue;
                            var maxVal = field.templateSegment.maxValue;
                            var minVal = field.templateSegment.minValue;

                            var aboveMax = (maxVal && value > maxVal);
                            var belowMin = (minVal && value < minVal);

                            /**
                                *  Creates an abnormal message string for the value depending on high and low values set.
                                * @returns {string}
                                */
                            var invalidValueFormatter = function()
                            {
                                var toReturn = 'This value is ';
                                var aboveMax = (maxVal && value > maxVal);
                                var belowMin = (minVal && value < minVal);

                                if (aboveMax)
                                    toReturn += 'above the normal ';
                                else if (belowMin)
                                    toReturn += 'below the normal ';
                                else
                                    return toReturn + 'abnormal.';

                                if (minVal && maxVal)
                                    return toReturn + ('range of ' + minVal + ' to ' + maxVal + '.');
                                else
                                    return toReturn + ((aboveMax) ? ' max of ' + maxVal : ' minimum of ' + minVal) + '.';
                            };

							htmlString = `<div class="${aboveMax || belowMin ? 'template-comment' : ''}">${templateValues.numericValue}</div>`;
							
                            if (aboveMax)
                            {
                                htmlString += '<br><div class="export-remove text-danger">' + (
                                    (field.templateSegment.aboveMaxAlertMessage || invalidValueFormatter())
                                ) + '</div>';
                            }
                            else if (belowMin)
                            {
                                htmlString += '<br><div class="export-remove text-danger">' + (
                                    (field.templateSegment.belowMinAlertMessage || invalidValueFormatter())
                                ) + '</div>';
                            }
                            return commentFormatter();
                        case 'Checkbox':
                            return commentFormatter(templateValues.stringValue == 'checked' ? '&#9745;' : '&#x2610;');
                        case 'Signoff':
                            function getExtraText(data, isReject) {
                                const key = isReject ? 'refutation' : 'attestation';
                                let res =  data[key];
                                return res ? `${res}<br>` : '';
                            }
                            const data = templateValues.signoffData || { signoffs: [] }
                            const strValues = $filter('orderBy')(data.signoffs, ['user.lastName', 'user.firstName']).map(signoff => {
                                const result = signoff.signoff === null
                                    ? 'Not Completed'
                                    : signoff.signoff
                                        ? `${getExtraText(data, false)}Signed Off`
                                        : `${getExtraText(data, true)}Rejected`;
                                return `${result} ${moment(signoff.signoffTime).format(' L HH:mm')} by ${signoff.user.firstName} ${signoff.user.lastName}`
                            })
                                .join('<hr>');
                            
                            return commentFormatter(strValues);
                        case 'User Chooser':
                            return commentFormatter(templateValues.userValue.firstName + ' ' + templateValues.userValue.lastName);
                        case 'Tag Choice':
                            return commentFormatter(templateValues.tagValues.map(function(tagValue) {
                                return tagValue.viewString;
                            }).join(', '));
                        case 'Signature':
                        case 'File Attachment':
                            if (type == 'display')
                            {
                                htmlString = formatAttachments(templateValues.fileAttachments, row.id, '');
                            }
                            return commentFormatter();
                        case 'Date/Time':
                            var forDisplay = type == 'display' || type == 'filter';
                            var toReturn;

                            var segment = templateValues.templateSegment;

                            if (segment.includeDate && segment.includeTime && templateValues.dateTimeValue)
                                toReturn = forDisplay ? (moment(templateValues.dateTimeValue)).format('L HH:mm') : templateValues.dateTimeValue;

                            else if (segment.includeDate && templateValues.dateValue)
                                toReturn = forDisplay ? (moment(templateValues.dateValue)).format('L') : templateValues.dateValue;

                            else if (segment.includeTime && templateValues.timeValue)
                                toReturn = templateValues.timeValue;

                            return commentFormatter(toReturn);

                        case 'Text Choice':
                            var choiceResult = field.templateSegment.choiceList.choices.find(function(value)
                            {
                                return templateValues.stringValue === value.value;
                            });
							var isAbnormal = (choiceResult && choiceResult.abnormal);
							
							htmlString = `<div class="${isAbnormal ? 'template-comment' : ''}">${templateValues.stringValue}</div>`;

                            if (isAbnormal)
                                htmlString += '<br><div class="export-remove text-danger">This value is abnormal.</div>';

                            return commentFormatter();

						default:
							const templateValue = templateValues.richTextValue || templateValues.markdown || templateValues.stringValue;
							const alignment = templateValues.richTextValue ? null : templateValues.templateSegment.textAlignment;

							return commentFormatter(templateValue, alignment);
                    }
                }
            };
        }

        var noteFieldColumns = {
            timeframe: {
                data: function (row, type, value, meta) {
                    return {
                        'noteTime': row.noteTime,
                        'carryForwardEndTime': row.carryForwardEndTime,
                        'carryForward': row.carryForward
                    };
                },
                title: 'Timeframe',
                className: 'text-center nf_17',
                type: 'timeframe',
                render: function(data, type, row, meta) {
                    var href = "'" + row._links.self.href + "'",
                        startDate = moment(data.noteTime).format('L HH:mm'),
                        endDate = data.carryForwardEndTime ? moment(data.carryForwardEndTime).format('L HH:mm') : null;

                        if (type == 'display') {
                            var htmlString = '';

                            if (!data.carryForward)
                                htmlString = '<div><a noteId="' + row.id + '" href ng-click="showNoteDetail(' + href + ', ' + meta.row + ')">' + startDate + '</a></div>';
                            else
                            {
                                if (!endDate)
                                {
                                    htmlString =
                                        '<div class="red-stripe" title="Active Carry Forward">' +
                                        '<div title="">' +
                                        '<a noteId="' + row.id + '" href ng-click="showNoteDetail(' + href + ', ' + meta.row + ')">' + startDate + '</a><span class="glyphicon glyphicon-time" style="margin-left: .25em"></span>' +
                                        '</div>' +
                                        '</div>';
                                }
                                else
                                {
                                    if (moment(endDate).isAfter(moment()))
                                    {
                                        htmlString =
                                            '<div class="red-stripe" title="Active Carry Forward">' +
                                            '<div title="">' +
                                            '<a title="" noteId="' + row.id + '" href ng-click="showNoteDetail(' + href + ', ' + meta.row + ')">' + startDate + '</a><span class="glyphicon glyphicon-time" style="margin-left: .25em"></span>' +
                                            '<br/><span>Ends at ' + endDate + '</span></div></div>';
                                    }
                                    else
                                    {
                                        htmlString =
                                            '<div class="blue-stripe" title="Ended Carry Forward">' +
                                            '<div title=""><a  noteId="' + row.id + '" href ng-click="showNoteDetail(' + href + ', ' + meta.row + ')">' + startDate + '</a><span class="glyphicon glyphicon-time" style="margin-left: .25em"></span>' +
                                            '<br/><span>Ended ' + endDate + '</span></div></div>';
                                    }
                                }
                            }

                        function NoteStatusIndicator(usingNote)
                        {
                            var selectedLog = $scope.selectedLog;
                            var note = usingNote;
                            var parseFields = {
                                'carryForwardEndTime': 'parsedCFEndTime',
                                'updated': 'parsedUpdated',
                                'created': 'parsedCreated'
                            };

                            var parseDateIfNeeded = function(dateField, parsedField)
                            {
                                if( !note[parsedField] )
                                    note[parsedField] = note[dateField]
                                        ? new Date(note[dateField].replace(/\+0000/,'Z'))
                                        : null;
                            };

                            var isModifiedRecently = function(note, modifiedTolerance)
                            {
                                Object.keys(parseFields).forEach(function(key) {
                                    parseDateIfNeeded(key, parseFields[key]);
                                });
                                return note.parsedUpdated
                                    && note.parsedCreated
                                    && note.parsedUpdated.getTime() - note.parsedCreated.getTime() > modifiedTolerance
                                    && note.numRevisions > 1;
                            };

                            /**
                             * Surrounds the htmlString with divs for indicator tags
                             * @param htmlString
                             * @return {string} Updated htmlString
                             */
                            this.setUpdatedColor = function(htmlString)
                            {
                                var modifiedTolerance = !isNaN(selectedLog.oopsEditMinutes)
                                    ?selectedLog.oopsEditMinutes*60000
                                    : 60000;

                                if ( note.newMillis )
                                {
                                    var appendingTitle = (!isModifiedRecently(note, modifiedTolerance) ? 'New Note' : 'Recently Modified');

                                    htmlString = '<div class="separator-stripe title="">' + htmlString + '</div>';
                                    htmlString = '<div class="new-note-stripe" title="' + appendingTitle +
                                        '">' + htmlString + '</div>';
                                }
                                else if ( isModifiedRecently( note, modifiedTolerance ) )
                                {
                                    htmlString = '<div class="separator-stripe" title="">' + htmlString + '</div>';
                                    htmlString = '<div class="modified-note-stripe" title="Modified">' + htmlString + '</div>';
                                }

                                return '<div style="text-align: center"' + htmlString + '</div>';
                            };
                        }

                        return tagStyleWrapper(new NoteStatusIndicator(row).setUpdatedColor(htmlString), meta, row.tagValues, 17, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                    }
                    if (type == 'filter') {
                        if (!data.carryForward)
                            return startDate;
                        else {
                            if (!endDate)
                                return startDate;
                            else {
                                if (moment(endDate).isAfter(moment()))
                                    return startDate + ' Ends at ' + endDate;
                                else
                                    return startDate + ' Ended ' + endDate;
                            }
                        }
                    }

                    return data;
                }
            },
            noteTime: {
                data: 'noteTime',
                title: 'Note Time',
                className: 'text-center nf_6',
                render: function(data, type, row, meta) {
                    var href = "'" + row._links.self.href + "'",
                        date = moment(data).format('L HH:mm');

                    if (type == 'display')
                        return tagStyleWrapper('<a noteId="' + row.id + '" href ng-click="showNoteDetail(' + href + ', ' + meta.row + ')">' + date + '</a>', meta, row.tagValues, 6, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                    if (type == 'filter')
                        return date;

                    return data;
                }
            },
            carryForwardEndTime: {
                data: 'carryForwardEndTime',
                title: 'End Time',
                className: 'text-center nf_16',
                render: function(data, type, row, meta) {
                    var href = "'" + row._links.self.href + "'",
                        date = data ? moment(data).format('L HH:mm') : '';

                    if (type == 'display')
                        return tagStyleWrapper('<a noteId="' + row.id + '" href ng-click="showNoteDetail(' + href + ', ' + meta.row + ')">' + date + '</a>', meta, row.tagValues, 16, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                    if (type == 'filter')
                        return date;

                    return data;
                }
            },
            note: {
                data: 'safeHtmlNote',
                title: 'Note',
                type: 'html',
                name: 'note',
                className: 'note nf_7',
                render: function(data, type, row, meta) {
					const numberOfComments = row.noteComments.length;
					const noteClass = 'note-table-note'
						+ (row.richText ? ' ql-editor p-p-0' : '')
						+ ($scope.selectedLog.role == 'READ' ? ' read-only-note' : '');
					
					let htmlString = `<div data-max-height="${row.maxHeight || ''}" class="${noteClass}">${data}</div>`;

                    htmlString = tagStyleWrapper(htmlString, meta, row.tagValues, 7, ($scope.reportView === 'Table') ? 'noteField' : 'override');

                    if (numberOfComments) {
                        var maxCommentsExceeded = row.commentsToShow && numberOfComments > row.commentsToShow,
							comments = getNoteCommentsHTML(row);
						
                        if (maxCommentsExceeded) {
                            htmlString +=
                                '<a class="toggle-more">Show More (' + numberOfComments + ' comments)</a>' +
                                '<div data-max-comments="' + row.commentsToShow + '">' + comments + '</div>';
                        }
                        else
                            htmlString += comments;
					}
					
                    return htmlString;
                }
            },
            attachments: {
                data: 'attachments',
                title: 'A',
                className: 'text-center nf_13',
                render: function(data, type, row, meta) {
                    if (!data.length)
                        return '';

                    if (type == 'display') {
                        var directiveScope = $scope.$new(true);
                        directiveScope.id = 'attachment-' + row._links.self.href + '-dropdown';
                        directiveScope.files = row.attachments;

                        row.directive = {
                            tdIndex: meta.col,
                            scope: directiveScope
                        };

                        var htmlString = '';
                        htmlString += '<file-attachment-dropdown files="files" dropdown-id="id"></file-attachment-dropdown>';
                        data.sort(function(val1, val2)
                        {
                            return (val1.contentType.includes("image")) ? 1 : -1;
                        });
                        htmlString = formatAttachments(data, row.id, htmlString);
                        htmlString = '<div style="display: block; text-align: center">' + htmlString + '</div>';
                        return tagStyleWrapper(htmlString, meta, row.tagValues, 13, ($scope.reportView === 'Table') ? 'noteField' : 'deny');

                    }
                    return data;
                }
            },
            turnover: {
                data: 'turnover',
                title: 'TN',
                className: 'text-center nf_8',
                render: function(data, type, row, meta) {
                    if (type == 'display') {
                        return tagStyleWrapper('<span>' + ((data) ? '&#9745;' : '&#x2610;') + '</span>', meta, row.tagValues, 8, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                    }
                    return data;
                }
            },
            carryForward: {
                data: 'carryForward',
                title: 'CF',
                className: 'text-center nf_15',
                render: function(data, type, row, meta) {
                    if (type == 'display') {
                        return tagStyleWrapper((data ? '<span class="glyphicon glyphicon-time">' : ''), meta, row.tagValues, 15, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                    }
                    return data;
                }
            },
            created: {
                data: 'created',
                title: 'Created',
                className: 'text-center nf_2',
                render: function(data, type, row, meta) {
                    if (type == 'display' || type == 'filter')
                        return tagStyleWrapper(moment(data).format('L HH:mm'), meta, row.tagValues, 2, ($scope.reportView === 'Table') ? 'noteField' : 'deny');

                    return data;
                }
            },
            createdBy: {
                data: 'createdBy',
                title: 'Created By',
                className: 'dt-body-left nf_3',
                render: function(data, type, row, meta) {
                    return tagStyleWrapper(data.firstName + ' ' + data.lastName, meta, row.tagValues, 3, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                }
            },
            updated: {
                data: 'updated',
                title: 'Updated',
                className: 'text-center nf_4',
                render: function(data, type, row, meta) {
                    if (type == 'display' || type == 'filter')
                        return tagStyleWrapper(moment(data).format('L HH:mm'), meta, row.tagValues, 4, ($scope.reportView === 'Table') ? 'noteField' : 'deny');

                    return data;
                }
            },
            updatedBy: {
                data: 'updatedBy',
                title: 'Updated By',
                className: 'dt-body-left nf_5',
                render: function(data, type, row, meta) {
                    return tagStyleWrapper(data.firstName + ' ' + data.lastName, meta, row.tagValues, 5, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                }
            },
            tagValues: {
                data: 'tagValues',
                title: 'Tags',
                className: 'dt-body-left nf_10',
                render: function(data, type, row, meta) {
                    return tagStyleWrapper(data.map(function(tagValue) {
                        return tagValue.viewString;
                    }).join(', '), meta, row.tagValues, 10, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                }
            },
            noteComments: {
                data: 'noteComments',
                title: 'Comments',
                type: 'html',
                className: 'dt-body-left nf_12',
                createdCell: function (td, cellData, rowData, row, col) {
                    var numberOfComments = rowData.noteComments.length,
                        maxCommentsExceeded = rowData.commentsToShow && numberOfComments > rowData.commentsToShow;

                    if (maxCommentsExceeded) {
                        td.innerHTML =
                            '<div data-max-comments="' + rowData.commentsToShow + '">' +
                                  td.innerHTML +
                            '</div>' +
                            '<a class="toggle-more">Show More (' + numberOfComments + ' comments)</a>';
                    }
                },
                render: function(data, type, row, meta) {
                    return tagStyleWrapper(getNoteCommentsHTML(row), meta, row.tagValues, 12, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                }
            },
            template: {
                data: 'templateName',
                title: 'Template',
                className: 'dt-body-left nf_14',
                render: function(data, type, row, meta)
                {
                    return tagStyleWrapper(data || '', meta, row.tagValues, 14, ($scope.reportView === 'Table') ? 'noteField' : 'deny')
                }
            },
            id: {
                data: 'id',
                title: 'ID',
                className: 'dt-body-right nf_1',
                render: function (data, type, row, meta)
                {
                    return tagStyleWrapper(data || '', meta, row.tagValues, 1, ($scope.reportView === 'Table') ? 'noteField' : 'deny')
                }
            },
            maxPriority: {
                data: 'maxPriority',
                title: 'Priority',
                type: 'html',
                className: 'dt-body-right nf_18',
                render: function(data, type, row, meta)
                {
                    return tagStyleWrapper(data, meta, row.tagValues, 18, ($scope.reportView === 'Table') ? 'noteField' : 'deny');
                }
            }
        };

        function getNoteCommentsHTML(rowData) {
            let divElement = document.createElement('div', {});
            let html = '';

            rowData.noteComments.forEach(function(noteComment, index) {
                let hideComment = rowData.commentsToShow && index >= rowData.commentsToShow;

                html += (hideComment ? '<em class="hide">' : '<em>')
                     +  moment(noteComment.updated).format('L HH:mm ')
                     +  noteComment.updatedBy.firstName + ' ' + noteComment.updatedBy.lastName
                     +  ': </em>'
                     + (hideComment ? '<p class="hide">' + noteComment.safeHtmlComment.slice(3) : noteComment.safeHtmlComment);
            });

            divElement.innerHTML = html;
            return divElement.outerHTML;
        }

        /**
         *  Formats an htmlString and appends the attachments
         * @param {array} attachments - Array of file objects
         * @param {string} htmlString - htmlString to append to
         */
        function formatAttachments(attachments, noteId, htmlString) {
			htmlString = htmlString || '';
			
            attachments.forEach(function (attachment, index) {
				let appending = '';
				let optStr = `onclick="window.previewFile(${attachment.id}, event)"`
    
				if (attachment.contentType && attachment.contentType.includes('image') && attachment.id) {
					appending += '<img alt="' +  attachment.id + '" src="/api/files/' + attachment.id + '?scale-height=200&inline=true"' +
                        ' onclick="window.viewImage(' + attachment.id + ', ' + noteId + '); return false;" style="margin-right: 10px; cursor: pointer;' +
						' margin-top: 5px;"><br>';
                    optStr = 'target="_blank"'
				}
				
                if (attachment.id)
					appending += `<a alt="${attachment.id}" style="display; block;" ${optStr} href="/#/files?fileId=${attachment.id}">${attachment.filename}</a>`;
				
                if (index <= attachments.length - 1)
					appending += '<br>';
				
                htmlString += '<div>' + appending + '</div>';
            });

            return htmlString;
        }

        /**
         * Get Tag Styling string from tagValues
         * @param {array} tagValues
         * @returns {string}
         */
        function getTagStyling(tagValues)
        {
            if (!tagValues || !tagValues.length) return '';
            tagValues = tagValues
                    .filter(function(tgVal)
                    {
                        return tgVal.styles && tgVal.styles.length;
                    })
                    .sort(function(o1, o2)
                    {
                        return (o2.priority - o1.priority);
                    })
                    .map(function(tgVal)
                    {
                        return tgVal.styles.map(function(style)
                        {
                            return style.description;
                        })
                    });

            return (tagValues.length) ? tagValues[0].join(' ') : '';
        }

        /**
         * Wraps the passed string in a div with the tagValues style values.
         * If only the item to wrap and index is passed, styling is pulled from $scope.tagStyles if present.
         * Otherwise the values in $scope.tagStyles are set by the other options when using this function.
         *
         * @param string - To wrap
         * @param {{row: string, col: string}} index - Index of items passed, for get/set
         * @param {array=} tagValues - To Style from
         * @param {number=} id - ID to match
         * @param {string=} idSelectOpt - Selection option to use. Defaults to 'column'. Options are 'column', 'noteField', 'override' and 'deny'.
         * @returns {string} - HtmlString
         */
        function tagStyleWrapper(string, index, tagValues, id, idSelectOpt)
        {
            var useStyle = false;

            if (tagValues && tagValues.length)
            {
                switch(idSelectOpt || 'column')
                {
                    case 'column':
                        useStyle = (id !== undefined && id < $scope.customFields.length && $scope.customFields[id].useTagStyle);
                        break;

                    case 'noteField':
                        var match = $scope.customFields.find(function(field)
                        {
                            return (field.noteField && field.noteField.id === id);
                        });
                        useStyle = (match && match.useTagStyle);
                        break;

                    case 'override':
                        useStyle = true;
                        break;

                    case 'deny':
                        useStyle = false;
                        break;
                }
            }

            var row = $scope.tagStyles[index.row] = $scope.tagStyles[index.row] || {};
            var styling = row[index.col] = (tagValues) ? getTagStyling(tagValues) : (row[index.col]) ? row[index.col] : '';

            return (useStyle || !tagValues) ? '<div style="" class="' + styling + '">'+ string + '</div>' : string;
        }
    
        /**
         * Removes export-remove class elements from a provided html string
         * @param htmlStr
         * @return {string|*}
         */
        function removeExportClass(htmlStr) {
            try {
                const parsed = parser.parseFromString(htmlStr, 'text/html');
                const elements = parsed.querySelectorAll('.export-remove');
                for (let el of elements) {
                    if (el.parentNode)
                        el.parentNode.removeChild(el);
                }
            
                if (parsed.body.firstElementChild)
                    return parsed.body.firstElementChild.innerHTML;
                else
                    return htmlStr;
                
            } catch (e) {
                console.error(e);
                return htmlStr;
            }
        }

        function getTableButtons()
        {
            var pdfHtmlFallback = function(doc)
            {
                var trimHtml = function(row)
                {
                    for (var i = 0; i < row.length; i++)
                    {
                        var node = row[i];
                        if (node.text)
                            node.text = node.text.replace(/<[^>]*>?/gm, '')
                    }
                };
                if (Array.isArray(doc.content) && doc.content.length >= 2 && doc.content[1].table)
                    doc.content[1].table.body.forEach(function(row)
                    {
                        trimHtml(row);
                    })
            };

            var pdfCustomize = function(doc, _, table) {

                var toRemove = [];
                var rootTable = doc.content[1].table.body;

                table.columns().every(function (index)
                {
                    if (!this.visible())
                    {
                        toRemove.push(index)
                    }
                });

                while (toRemove.length)
                {
                    var indexToRemove = toRemove.pop();
                    rootTable.forEach(function(row)
                    {
                       row.splice(indexToRemove, 1);
                    });
                }

                doc.images = Object.keys((JSON.parse(sessionStorage.getItem('imageFiles')) || {}))
                    .reduce(function(imageObj, value)
                    {
                        $.ajax('/api/batch',
                            {
                                type: 'POST',
                                contentType: 'application/json',
                                data: JSON.stringify([{
                                    method: 'GET',
                                    uri: '/api/files/' + value + '?scale-height=100&inline=true'
                                }]),
                                async: false,
                                success: function(data)
                                {
                                    imageObj[value] = 'data:' + data[0].headers['Content-Type'] + ';base64, ' + data[0].responseBody;
                                }
                            });

                        return imageObj;
                    }, {});

                var save = {};
                Object.defineProperty(save, 'content', { value: JSON.parse(JSON.stringify(doc.content)) });

                window.downloadReady = false;
                try
                {
                    $scope.pdfBaseUrl = $location.search()['pdfBaseUrl'];
                    formatPDF(doc, $scope);
                }
                catch(e)
                {
                    console.error(e);
                    console.error('Failed formatting. Falling back to stripping html.');
                    try
                    {
                        errorHandler.handle('Format PDF Failure', e.stack, false);
                        Object.defineProperty(doc, 'content', { value: save.content });
                        pdfHtmlFallback(doc);
                    }
                    catch(x)
                    {
                        console.error(x);
                        console.error('Failed on fallback. Displaying error message.');
                        errorHandler.handle('Issue occurred during PDF Export', e.stack, true);

                        // Throw Exception to prevent PDF download
                        throw e;
                    }
                }
                $scope.updateReportNoteCount();
                window.downloadReady = true;
            };
            return [
                {
                    extend: 'collection',
                    text: 'Export',
                    autoClose: true,
                    buttons: [
                        {
                            extend: 'pdfHtml5',
                            text: 'PDF - Landscape',
                            pageSize: 'letter',
                            orientation: 'landscape',
                            filename: $scope.report.name,
                            className: 'export-pdf-landscape',
                            customize: pdfCustomize,

                            exportOptions: {
                                stripHtml: false
                            }
                        },
                        {
                            extend: 'pdfHtml5',
                            text: 'PDF - Portrait',
                            pageSize: 'letter',
                            orientation: 'Portrait',
                            filename: $scope.report.name,
                            className: 'export-pdf-portrait',
                            customize: pdfCustomize,

                            exportOptions: {
                                stripHtml: false
                            }
                        },
                        {
                            extend: 'excel',
                            title: null,
                            exportOptions: pdfExcelExportOptions,
                            filename: $scope.report.name,
                            className: 'export-excel',
                            customize: function(xlsx) {
                                var cellXfs = $('cellXfs', xlsx.xl['styles.xml']);

                                // See https://datatables.net/forums/discussion/39287/datatables-buttons-excelhtml5-vertical-cell-alignment
                                cellXfs.append(
                                    '<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1">'
                                    + '<alignment vertical="top" wrapText="1" />'
                                    + '</xf>'
                                );

                                var sheet = xlsx.xl.worksheets['sheet1.xml'],
                                    startIndex = _table.columns().count() - 1;

                                $(sheet).find('c:gt(' + startIndex + ')').attr('s', cellXfs[0].childElementCount - 1);
                                $scope.updateReportNoteCount();
                                window.downloadReady = true;
                            }
                        },
                        {
                            extend: 'csv',
                            className: 'export-csv',
                            exportOptions: {
                                columns: ':visible:not(.note)',
                                format: {
                                    body: function(data, row, column, node)
                                    {
                                        data = removeExportClass(data);
                                        return typeof data === 'number'
                                            ? data
                                            : data.replace(/<[^>]*>?/gm, '') //Strips HTML
                                                .replace(/&#9745;/g, 'Yes')
                                                .replace(/&#x2610;/g, 'No');
                                    }
                                }
                            },
                            customize: function(csv)
                            {
                                $scope.updateReportNoteCount();
                                window.downloadReady = true;
                                return csv;
                            },
                            filename: $scope.report.name
                        }
                    ]
                },
                {
                    extend: 'colvis',
                    text: 'Column Visibility'
                }
            ];
        }

        var pdfExcelExportOptions = {
            columns: ':visible',
            format: {
                body: function (data, row, column, node) {
                    data = removeExportClass(data);
                    
                    if (column == _table.column('note:name').index('visible')) {
                        var text = '',
                            markdown = $scope.notes[row].safeHtmlNote.split('\n'),
                            comments = $scope.notes[row].noteComments;

                        markdown.forEach(function(line) {
                            var values = line.split('|'),
                                heading = values[0].trim();

                            if (heading) {
                                text += '\n\n' + heading.replace(/#/g, '').trim().toUpperCase();
                            }
                            else if (values.length > 1) {
                                var key = values[1].trim(),
                                    skip = !key || key.indexOf(':---') == 0;

                                if (!skip) {
                                    text += '\n' + key + ':    ' + values[2].trim();
                                }
                            }
                        });

                        if (comments.length) {
                            text += '\n\n' + 'Comments:';
                        }
                        comments.forEach(function(comment) {
                            text += '\n' + comment.createdBy.firstName + ' ' + comment.createdBy.lastName + ' (' + moment(comment.updated).format('L HH:mm') + ')';
                            text += '\n' + comment.comment;
                        });

                        return text.trim()
                            .replace(/&#9745;/g, 'Yes')
                            .replace(/&#x2610;/g, 'No')
                            .replace(/<[^>]*>?/gm, ''); //Strips HTML
                    }
    
                    return typeof data === 'number'
                        ? data
                        : data.replace(/<[^>]*>?/gm, '') //Strips HTML
                            .replace(/&#9745;/g, 'Yes')
                            .replace(/&#x2610;/g, 'No');
                }
            }
        };

        $outputTable.on('page.dt', function() {
            this.parentElement.scrollTop = 0;
        })
        .on('click', '.toggle-more', function() {
            var showMore = this.innerHTML.includes('Show More'),
                linkText = showMore ? 'Show Less' : 'Show More';

            var $siblings =  $(this).siblings(),
                $maxHeightDiv = $siblings.filter('[data-max-height]'),
                $maxCommentsDiv = $siblings.filter('[data-max-comments]');

            if ($maxHeightDiv.length)
                $maxHeightDiv.css('max-height', showMore ? '' : $maxHeightDiv.data('maxHeight'));

            if ($maxCommentsDiv.length) {
                var hideStartIndex = $maxCommentsDiv.data('maxComments') * 2 - 1;
                let $comments = $maxCommentsDiv.children();

                $comments.filter('*:gt(' + hideStartIndex + ')').toggleClass('hide', !showMore);

                if (!showMore)
                    linkText += ' (' + Math.floor($comments.length / 2) + ' comments)';

                if (this.parentElement.className.trim() != 'note')
                    _table.columns.adjust();
            }

            this.innerHTML = linkText;
        })
        .on('column-visibility.dt', function(e, settings, column, state) {
            // Handles case where Note column has been hidden, visible records are changed, and Note column is then made visible again
            if (state && column == _table.column('note:name').index())
                checkIfMaxHeightNeeded();
        });

        $.extend($.fn.dataTable.ext.type.order, {
            "timeframe-asc": function ( a, b ) {
                a.isActive = !a.carryForward ? false : !a.carryForwardEndTime ? true : moment(a.carryForwardEndTime).isAfter(moment()) ? true : false;
                b.isActive = !b.carryForward ? false : !b.carryForwardEndTime ? true : moment(b.carryForwardEndTime).isAfter(moment()) ? true : false;
                if (a.isActive && !b.isActive) return 1;
                else if (b.isActive && !a.isActive) return -1;
                else if (a.isActive && b.isActive) return moment(a.noteTime).diff(moment(b.noteTime));
                else {
                    var aDate = a.carryForward ? moment(a.carryForwardEndTime) : moment(a.noteTime),
                        bDate = b.carryForward ? moment(b.carryForwardEndTime) : moment(b.noteTime);
                    return aDate.diff(bDate);
                }
            },
            "timeframe-desc": function ( a, b ) {
                a.isActive = !a.carryForward ? false : !a.carryForwardEndTime ? true : moment(a.carryForwardEndTime).isAfter(moment()) ? true : false;
                b.isActive = !b.carryForward ? false : !b.carryForwardEndTime ? true : moment(b.carryForwardEndTime).isAfter(moment()) ? true : false;
                if (a.isActive && !b.isActive) return -1;
                else if (b.isActive && !a.isActive) return 1;
                else if (a.isActive && b.isActive) return moment(b.noteTime).diff(moment(a.noteTime));
                else {
                    var aDate = a.carryForward ? moment(a.carryForwardEndTime) : moment(a.noteTime),
                        bDate = b.carryForward ? moment(b.carryForwardEndTime) : moment(b.noteTime);
                    return bDate.diff(aDate);
                }
            }
        });

        /**
         * Sets an auto refresh countdown with provided number of seconds or uses the saved value.
         * Setting a value below 30 cancels auto refresh.
         * @param {number|String=} seconds - The number of seconds to wait before the auto refresh is triggered.
         */
        function autoRefreshTimeSet(seconds)
        {
            if ($scope.destroyed || runningScheduledReport) return;
            
            seconds = parseInt(seconds);
            $scope.autoRefeshSeconds = (!isNaN(seconds))
                ? seconds
                : ($scope.autoRefeshSeconds)
                    ? $scope.autoRefeshSeconds
                    : null;

            clearTimeout($scope.autoRefreshId);

            if (!$scope.autoRefeshSeconds || $scope.autoRefeshSeconds < 30)
                return;

            console.log('Seconds set:', $scope.autoRefeshSeconds);

            var refreshId = -1;
            if (!$scope.queryExecuting && $scope.hadFirstRun)
                refreshId = $scope.autoRefreshId = setTimeout(function()
                {
                    console.log('Auto Refresh ID:', refreshId, 'executing.');
                    if (!$scope.queryExecuting)
                        $scope.updated(true);
                }, $scope.autoRefeshSeconds * 1000);

            console.log('Auto refresh ID:', refreshId);
        }

        $scope.setRefreshTime = function(seconds, setUrlParam, $refreshOpt)
	    {
		    $refreshOpt = $refreshOpt || $('.refresh-option[value="' + seconds + '"]');
		    $('.refresh-option.checked').removeClass('checked');
		    $refreshOpt.addClass('checked');

		    if (setUrlParam)
			    $timeout(function()
			    {
				    $location.search('refreshRate', seconds).replace();
			    });

		    autoRefreshTimeSet(seconds || 0)
	    };

        $('.refresh-option').click(function(e)
        {
            var $this = $(this);
            var value = $this.attr('value');

            $scope.setRefreshTime(value, true, $this);
            e.stopPropagation();
        });

        $('.refresh-setting').click(function(e)
        {
            var $this = $(this);
            var settingName = $this.attr('value');
            var settingValue = $this.hasClass('checked');

            $scope.setAutoRefreshSetting(settingName, !settingValue);
            e.stopPropagation();
        });

        $scope.setAutoRefreshSetting = function(settingName, settingValue)
        {
            if (settingName === null || settingValue === null && !runningScheduledReport) return;
            settingValue = (typeof settingValue === 'string') ? settingValue === 'true' : settingValue;

            var $setting = $('.refresh-setting[value="' + settingName + '"]');

            if (settingValue)
                $setting.addClass('checked');
            else
                $setting.removeClass('checked');

            switch(settingName)
            {
                case 'fullResults':
                    $scope.autoRefreshFull = settingValue;
                    $timeout(function()
                    {
                    	$location.search('fullResults', settingValue).replace()
                    });
                    break;
            }
        };
        
        const executeDownload = () => {
            try {
                if (runningScheduledReport && _table && typeof _table.buttons === 'function')
                {
                    switch (outputType) {
                        case 'pdf-portrait':
                            _table.buttons('.export-pdf-portrait').trigger();
                            break;
                        case 'pdf-landscape':
                            _table.buttons('.export-pdf-landscape').trigger();
                            break;
                        case 'excel':
                            _table.buttons('.export-excel').trigger();
                            break;
                        case 'csv':
                            _table.buttons('.export-csv').trigger();
                            break;
                        default:
                            window.exportError = true;
                            return;
                    }
                }
                else {
                    window.exportError = true;
                }
            }
            catch (e) {
                window.exportError = true;
            }
        };

		$('body').keydown(function(e) {
			if (ImageViewerComponent.isOpen)
				return;

            if (!$(e.target).is(':input, [contenteditable]') && _table) {
                if (e.keyCode === 37) // left arrow
                    _table.page('previous').draw('page');
                else if (e.keyCode === 39) // right arrow
                    _table.page('next').draw('page');
            }
        });

        $scope.updateReportNoteCount = function() {
           window.reportNoteCount = $scope.notes ? $scope.notes.length : undefined;
        };

        $scope.$on('$destroy', function()
        {
            $('body').off('keydown');
            $scope.queryExecuting = false;
            if ($scope.autoRefreshId)
                clearTimeout($scope.autoRefreshId);

            $scope.destroyed = true;
        });
        
        $scope.$watch('queryExecuting', function()
        {
            if ($scope.queryExecuting === false)
            {
                window.reportLoaded = true;
                if (runningScheduledReport)
                    executeDownload();
            }
        })

        $scope.$watch(function() {
            return $rootScope.selectedLog;
        }, function(newVal, oldVal) {
            
            if (newVal && $scope.currentLog && newVal.id !== $scope.currentLog.id) {
                // Redirect to report-manager on log change
                $location.url('/report-manager');
            }
            else if (newVal && newVal.hasOwnProperty('id'))
                $scope.currentLog = newVal;
        });

    }
]);